import { css } from '@emotion/react';
import { FontWeight } from '@revenuemarket/design/types';

import { theme } from '../styled';

/**
 * variant에 맞는  값을 반환
 *
 * @param variant
 * @param weight
 * @returns
 */
export function getTypographyCss(variant: keyof typeof theme.typography, weight: FontWeight = 400) {
  return css`
    font-size: ${theme.typography[variant].size}px;
    line-height: ${theme.typography[variant].lineHeight}px;
    font-weight: ${theme.typography[variant].weight};
  `;
}
